if (window.ASSET_URL) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = window.ASSET_URL;
}
